<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getPartGoodReceipts" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber"
							optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Purchase Order" id="filter-"
							size="sm" :model.sync="filter.purchaseOrderId" @input="getPurchaseOrders"
							@focus="getPurchaseOrders" />
						<app-input-textbox id="fieldset-part-good-receipt-number" label-cols-sm="4" label-cols-lg="3"
							label="Part Good Receipt Number" label-for="filter-part-good-receipt-number" size="sm"
							:model.sync="filter.partGoodReceiptNumber" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker-range id="fieldset-part-good-receipt-date" label-cols-sm="4"
							label-cols-lg="3" label="Part Good Receipt Date" size="sm"
							:modelFrom.sync="filter.partGoodReceiptDateFrom"
							:modelTo.sync="filter.partGoodReceiptDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />
						<app-input-textbox id="fieldset-surat-jalan" label-cols-sm="4" label-cols-lg="3"
							label="Surat Jalan" label-for="filter-surat-jalan" size="sm"
							:model.sync="filter.suratJalan" />
						<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark"
							label-for="filter-remark" size="sm" :model.sync="filter.remarkMultiple" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear
							Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1"
							@click="getPartGoodReceipts"><span style="font-size: 0.75rem"
								class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Part Good Receipt</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm"
							v-if="false && (userRole != null && (userRole.allowDownload || userRole.allowUpload || userRole.allowPrint))">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/partgoodreceipt/PartGoodReceipt.xlsx"><b-icon-wallet
									class="mr-1"></b-icon-wallet>
								Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpload : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item>
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
								<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="isShowDeleteButton" class="btn-action d-sm-none d-md-inline" size="sm"
						@click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton" :show="isDeleteBusy" rounded opacity="0.6" spinner-small
						spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action d-sm-none d-md-inline" size="sm"
						@click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
			countFilter(filter) }} </b-button>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="showOutstanding()">Outstanding
						Transaction</b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-partgoodreceipt"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light"
					:bordered="true" :no-local-sorting="true" :items="partGoodReceipts" :fields="fields"
					:busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty
					:tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="partGoodReceipts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Purchase Order Number" class="table-filter">
							<v-select append-to-body label="purchaseOrderNumber" :options="purchaseOrders"
								:value="filter.purchaseOrderId" :reduce="item => item.id"
								v-model="filter.purchaseOrderId" :filterable="true"
								@input="getPartGoodReceiptsWithoutLoading" @search="getPurchaseOrders"></v-select>
						</b-th>
						<b-th stacked-heading="Part Good Receipt Number" class="table-filter">
							<b-form-input id="input-part-good-receipt-number-table"
								@input="getPartGoodReceiptsWithoutLoading" v-model="filter.partGoodReceiptNumber"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Part Good Receipt Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder=""
								id="input-part-good-receipt-date-from-table" reset-button
								@input="getPartGoodReceiptsWithoutLoading" v-model="filter.partGoodReceiptDateFrom"
								size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder=""
								id="input-part-good-receipt-date-to-table" reset-button
								@input="getPartGoodReceiptsWithoutLoading" v-model="filter.partGoodReceiptDateTo"
								size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="Surat Jalan" class="table-filter">
							<b-form-input id="input-surat-jalan-table" @input="getPartGoodReceiptsWithoutLoading"
								v-model="filter.suratJalan" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Remark" class="table-filter">
							<b-form-input id="input-remark-table" @input="getPartGoodReceiptsWithoutLoading"
								v-model="filter.remark" size="sm"></b-form-input>
						</b-th>

						<!-- <b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)"
								id="input-select-all" class="float-right d-block d-md-none"
								v-model="selectAll"></b-form-checkbox>
						</b-th> -->
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(purchaseOrderNumber)="row">
						<a @click="checkForNextPage(row.item)" class="a-link-detail">
							{{ row.item.purchaseOrder != null && row.item.purchaseOrder.purchaseOrderNumber != null &&
			row.item.purchaseOrder.purchaseOrderNumber != "" ?
			(typeof row.item.productCode == 'string') ?
				row.item.purchaseOrder.purchaseOrderNumber.slice(0, 30) +
				(row.item.purchaseOrder.purchaseOrderNumber.length > 30 ? "..." : "") :
				row.item.purchaseOrder.purchaseOrderNumber : "" }}
						</a>
					</template>

					<!-- <template v-slot:cell(purchaseOrderNumber)="row">
						{{ row.item.purchaseOrder != null ? row.item.purchaseOrder.purchaseOrderNumber : "" }}
					</template> -->
					<template v-slot:cell(partGoodReceiptDate)="row">
						{{ row.item.partGoodReceiptDate | moment("DD-MMM-YYYY") }}
					</template>
					<template v-slot:cell(remark)="row">
						<app-long-text :id="'remark-' + row.index"
							:text="row.item != null ? (row.item.remark != null && row.item.remark != '' ? row.item.remark : '') : ''" />
					</template>

					<!-- <template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template> -->
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-label label-cols-lg="12" size="sm" type="generatednumber"
								label="Part Good Receipt Number" :model="row.item.partGoodReceiptNumber" />
							<app-input-datepicker id="fieldset-part-good-receipt-date" label-cols-lg="12"
								label="Part Good Receipt Date" size="sm" :model.sync="row.item.partGoodReceiptDate"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB" :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-surat-jalan" label-cols-lg="12" label="Surat Jalan"
								label-for="input-surat-jalan" size="sm" :model.sync="row.item.suratJalan"
								:isEditable="false" :isUpdatable="true" />
							<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
								label-for="input-remark" size="sm" :model.sync="row.item.remark" :isEditable="false"
								:isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(partGoodReceiptsPaging != null ? partGoodReceiptsPaging.dataCount : 0)"
									:per-page="(partGoodReceiptsPaging != null ? partGoodReceiptsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId"
			@resetModalMethod="resetModal" label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-partgoodreceipt.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-partgoodreceipt.b-table>thead>tr>th {
	background: #e28b29;
}

::v-deep #table-list-partgoodreceipt.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}
</style>
<script>
import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptList from '@/models/PartGoodReceipt/PartGoodReceiptList';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		PartGoodReceipt,
		PartGoodReceiptList,
		PartGoodReceiptFilter,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "purchaseOrderNumber": {}, "class": "th-purchase-order first-child", "label": "Purchase Order Number", key: 'purchaseOrderNumber', sortable: true },
				// { "purchaseOrderNumber": {}, "class": "th-purchase-order-number", "label": "Purchase Order Number", key: 'purchaseOrderNumber', sortable: true },
				{ "partGoodReceiptNumber": {}, "class": "th-part-good-receipt-number last-child", "label": "Part Good Receipt Number", key: 'partGoodReceiptNumber', sortable: true },
				{ "partGoodReceiptDate": {}, "class": "th-part-good-receipt-date d-stack-none", "label": "Part Good Receipt Date", key: 'partGoodReceiptDate', sortable: true },
				{ "suratJalan": {}, "class": "th-surat-jalan d-stack-none", "label": "Surat Jalan", key: 'suratJalan', sortable: true },
				{ "remark": {}, "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: true },

				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			partGoodReceipts: [],
			partGoodReceiptsPaging: {},
			purchaseOrders: [],
			partGoodReceiptDetails: [],
			partGoodReceiptCases: [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			isOutstandingTransaction: false,
		}
	}, methods: {
		checkForNextPage: function (item) {
			if (item.partGoodReceiptNumber) {
				return this.$router.push({ name: 'partgoodreceiptdetail', params: { id: item.id } })
			}
			return this.$router.push({ name: 'partgoodreceiptscan', params: { id: item.id } })
		},
		showOutstanding: function () {
			this.isOutstandingTransaction = !this.isOutstandingTransaction;
			this.getPartGoodReceipts();
		},
		getPartGoodReceipts: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.filter.draftMode = this.isOutstandingTransaction ? 1 : 0;
			PartGoodReceipt.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.partGoodReceipts = result.data
						this.partGoodReceiptsPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getPartGoodReceiptsWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PartGoodReceipt.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.partGoodReceipts = result.data
						this.partGoodReceiptsPaging = result
					}
				})
				.catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			if(this.filter.purchaseOrderId != undefined && input == '') {
				filter.id = this.filter.purchaseOrderId;
			}
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new PartGoodReceiptFilter();
			this.getPartGoodReceipts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPartGoodReceipts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PartGoodReceipt.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PartGoodReceipt.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PartGoodReceipt.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},
		createData() {
			this.isCreateBusy = true;
			PartGoodReceipt.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'partgoodreceiptedit';
						if (this.isScannerMode) {
							createRoute = 'partgoodreceiptscan';
						}

						this.$router.push({ name: createRoute, params: { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PartGoodReceipt.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'partgoodreceiptedit', params: { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PartGoodReceipt.deleteData(this, id).then(result => {
				if (result) {
					this.getPartGoodReceipts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PartGoodReceipt.deleteMultipleData(this).then(result => {
					this.getPartGoodReceipts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePartGoodReceiptParent = document.getElementById('table-list-partgoodreceipt').parentNode;
			tablePartGoodReceiptParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePartGoodReceiptParent.scrollWidth - tablePartGoodReceiptParent.offsetWidth) == Math.ceil(tablePartGoodReceiptParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePartGoodReceiptParent = document.getElementById('table-list-partgoodreceipt').parentNode;
			tablePartGoodReceiptParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePartGoodReceiptParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PartGoodReceiptFilter();
		// this.getPurchaseOrders()
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Part Good Receipt"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPartGoodReceipts();
			this.getPurchaseOrders();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getPartGoodReceipts();
			}
		},
		sortDesc: {
			handler: function () {
				this.getPartGoodReceipts();
			}
		},
		currentPage: {
			handler: function () {
				this.getPartGoodReceipts();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getPartGoodReceipts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PartGoodReceipt.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "partgoodreceiptindex") {
					this.getPartGoodReceiptsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "part_good_receipt").first();
		},
		isShowDeleteButton: function () {
			return false;
			/*let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;*/
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
